import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AppStatusState = {
  isOffline: boolean;
};

const initialState: AppStatusState = {
  isOffline: typeof navigator !== 'undefined' ? !navigator.onLine : false
};

export const appStatusSlice = createSlice({
  name: 'appStatus',
  initialState,
  reducers: {
    setIsOffline: (state, action: PayloadAction<boolean>) => {
      state.isOffline = action.payload;
    }
  }
});

export const { setIsOffline } = appStatusSlice.actions;
export default appStatusSlice.reducer;
